import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import {
  getListClient,
  getClientDetails,
  createNewClient,
  revokeClient,
  refreshClient,
} from '../../redux/actions/delivery';

import ClientList from './ClientList.page';
import { resetFilter } from '../../../../redux/actions/newFilter';

const mapStateToProps = state => ({
  clientList: state.delivery.clientList,
  clientFilter: state.delivery.clientFilter,
  loading: state.delivery.loading,
  filterValue: state.newFilter.filterValue,
  formControlShow: state.newFilter.formControlShow,
  clientDetails: state.delivery.clientDetails,
  getClientDetailsLoading: state.delivery.getClientDetailsLoading,
  createNewClientLoading: state.delivery.createNewClientLoading,
  revokeClientLoading: state.delivery.revokeClientLoading,
  refreshClientLoading: state.delivery.refreshClientLoading,
});

const mapDispatchToProps = {
  getListClient,
  resetFilter,
  getClientDetails,
  createNewClient,
  revokeClient,
  refreshClient,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(ClientList));
